import ConfigHelperProd from "../ConfigHelper-prod";
import ConfigHelperDev from "../ConfigHelper-dev";
import ConfigHelperGCProd from "../ConfigHelperGC-prod";
import ConfigHelperGCDev from "../ConfigHelperGC-dev";

export function getENVData() {
    if (window.location.hostname === "trip.travelsment.com") {
        return ConfigHelperProd;
    }
    else if (window.location.hostname === "dev.travelsment.com") {
        return ConfigHelperDev;
    }
    else if (window.location.hostname === "trip.familytc.com") {
        return ConfigHelperGCProd;
    }
    else if (window.location.hostname === "dev.familytc.com") {
        return ConfigHelperGCDev;
    }
    else {
        return ConfigHelperProd;
    }
}

export function isDev() {
    return window.location.hostname !== "trip.travelsment.com" && window.location.hostname !== "trip.familytc.com";
}

export const isLocalDev = window.location.hostname.indexOf("local") !== -1;
